export class Message {
    'message';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "message",
            "baseName": "message",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Message.attributeTypeMap;
    }
    constructor() {
    }
}
